import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';
import config from 'config/index';

interface IProps
  extends DetailedHTMLProps<
    ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  imagePath: string;
  type: string;
}

export const getCityImageUrl = (
  type: string,
  imagePath?: string,
  defaultImage: string = '/3720_000_1/20141225144755098_KSFOPP56G.JPG/Mid-Hudson_ballo.JPG',
) => `${config.photoInfra}${imagePath || defaultImage}?type=${type}`;

export default function CityImage({ imagePath, type, ...props }: IProps) {
  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      src={getCityImageUrl(type, imagePath)}
      onError={e => {
        (e.target as HTMLImageElement).src = getCityImageUrl(type);
      }}
    />
  );
}
